export const ACCESS_POINT_RECORDS_TABLE_ID = 'accessPointRecordTable';
// Set to maximum page size to get all data at once
export const ACCESS_POINT_RECORDS_REQUEST_PAGE_SIZE = 10_000;
export const ACCESS_POINT_RECORDS_DISPLAY_DEFAULT_PAGE_SIZE = 25;
